import { defineComponent as _defineComponent } from 'vue'
import MyProjectsContractList from '@/views/my-projects/components/contracts/MyProjectsContractList.vue';
import MyProjectsContractsActions from '@/views/my-projects/components/contracts/MyProjectsContractsActions.vue';
import useProjectsContractsActionState from '@/views/my-projects/components/contracts/myProjectsContractsActionState';
import { onMounted, onUnmounted } from 'vue';
import useContractOverview from '../composables/useContractOverview';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsContracts',
  setup(__props) {

const { mode } = useProjectsContractsActionState();
mode.value = '';

const { fetchContracts, allContracts } = useContractOverview();

onMounted(() => {
  fetchContracts();
});

onUnmounted(() => {
  allContracts.value = [];
});

return { __sfc: true,mode, fetchContracts, allContracts, MyProjectsContractList, MyProjectsContractsActions }
}

})